const Container = ({ children, className, fullWidthOnMobile = false }) => {
  return <div className={`${fullWidthOnMobile ? "w-full" : "px-[20px]"} md:px-[100px] ${className}`}>{children}</div>;
};

export default Container;
